import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { localStorageColorSchemeManager } from "./auth-service-tools203.js";
import { MantineContext } from "./auth-service-tools199.js";
import { MantineClasses } from "./auth-service-tools221.js";
import { MantineCssVariables } from "./auth-service-tools222.js";
import "react";
import { MantineThemeProvider } from "./auth-service-tools196.js";
import { suppressNextjsWarning } from "./auth-service-tools223.js";
import { useProviderColorScheme } from "./auth-service-tools216.js";
import { useRespectReduceMotion } from "./auth-service-tools224.js";
suppressNextjsWarning();

function MantineProvider(_ref) {
  let {
    theme,
    children,
    getStyleNonce,
    withStaticClasses = true,
    withGlobalClasses = true,
    deduplicateCssVariables = true,
    withCssVariables = true,
    cssVariablesSelector = ":root",
    classNamesPrefix = "mantine",
    colorSchemeManager = localStorageColorSchemeManager(),
    defaultColorScheme = "light",
    getRootElement = () => document.documentElement,
    cssVariablesResolver,
    forceColorScheme,
    stylesTransform
  } = _ref;
  const {
    colorScheme,
    setColorScheme,
    clearColorScheme
  } = useProviderColorScheme({
    defaultColorScheme,
    forceColorScheme,
    manager: colorSchemeManager,
    getRootElement
  });
  useRespectReduceMotion({
    respectReducedMotion: (theme == null ? void 0 : theme.respectReducedMotion) || false,
    getRootElement
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(MantineContext.Provider, {
    value: {
      colorScheme,
      setColorScheme,
      clearColorScheme,
      getRootElement,
      classNamesPrefix,
      getStyleNonce,
      cssVariablesResolver,
      cssVariablesSelector,
      withStaticClasses,
      stylesTransform
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsxs(MantineThemeProvider, {
      theme,
      children: [withCssVariables && /* @__PURE__ */jsxRuntimeExports.jsx(MantineCssVariables, {
        cssVariablesSelector,
        deduplicateCssVariables
      }), withGlobalClasses && /* @__PURE__ */jsxRuntimeExports.jsx(MantineClasses, {}), children]
    })
  });
}

MantineProvider.displayName = "@mantine/core/MantineProvider";
export { MantineProvider };